const App = 'Yard-Gate';

export default App;
